import React from 'react';
import { ArrowLong } from '../../assets/img/svg/icons';

interface PaginationProps {
  page: number;
  max: number;
  setPage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, max, setPage }) => {
  const totalPages = Math.max(1, max);
  const visiblePages = 5;

  let start = Math.max(1, page - Math.floor(visiblePages / 2));
  let end = Math.min(totalPages, start + visiblePages - 1);

  if (end - start < visiblePages - 1) {
    start = Math.max(1, end - visiblePages + 1);
  }

  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <nav className="flex justify-center items-center gap-4 text-sm flex-wrap">
      <button
        onClick={() => page > 1 && setPage(page - 1)}
        disabled={page === 1}
        className={`transition-all duration-200 font-semibold flex items-center gap-4 group ${
          page > 1 ? "text-main-pink hover:text-main-blue" : "text-gray-400 cursor-default"
        }`}
      >
        <ArrowLong className={`transition-all duration-200 fill-main-pink -scale-x-100 group-hover:fill-main-blue ${page === 1 && "opacity-50"}`} />
        Anterior
      </button>

      <div className="-order-1 md:order-none w-full md:w-auto flex justify-center">
        <div className="bg-main-pink rounded-full shadow inline-flex items-center gap-2 px-2">
          {pages.map((num) => (
            <button
              key={num}
              onClick={() => setPage(num)}
              className={`h-8 w-8 rounded-full inline-flex justify-center items-center text-sm transition-all duration-200 ${
                num === page
                  ? "bg-white text-main-pink scale-105 font-bold"
                  : "bg-white hover:bg-main-blue hover:text-white"
              }`}
            >
              {num}
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={() => page < totalPages && setPage(page + 1)}
        disabled={page === totalPages}
        className={`transition-all duration-200 font-semibold flex items-center gap-4 group ${
          page < totalPages ? "text-main-pink hover:text-main-blue" : "text-gray-400 cursor-default"
        }`}
      >
        Próximo
        <ArrowLong className={`transition-all duration-200 fill-main-pink group-hover:fill-main-blue ${page === totalPages && "opacity-50"}`} />
      </button>
    </nav>
  );
};

export default Pagination;